import React, { useState } from 'react';
import Button from '../../Button';
import { userService } from '../../../api/services/UserService';

type AdminRole = 'admin' | 'companyAdmin';

const CreateAdminForm: React.FC = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isEmailConfirmed, setIsEmailConfirmed] = useState(true);
  const [loading, setLoading] = useState<AdminRole | null>(null);
  const [message, setMessage] = useState<{ type: 'success' | 'danger'; text: string } | null>(null);

  const resetForm = () => {
    setFirstName('');
    setLastName('');
    setEmail('');
    setPassword('');
    setIsEmailConfirmed(true);
  };

  const handleSubmit = async (role: AdminRole) => {
    if (!firstName.trim() || !lastName.trim() || !email.trim() || !password.trim()) {
      setMessage({ type: 'danger', text: 'Tüm alanları doldurun.' });
      return;
    }

    setLoading(role);
    setMessage(null);

    const payload = {
      firstName: firstName.trim(),
      lastName: lastName.trim(),
      email: email.trim(),
      password,
      isEmailConfirmed,
    };

    try {
      const res =
        role === 'admin'
          ? await userService.createAdmin(payload)
          : await userService.createCompanyAdmin(payload);

      if (res.isSuccess) {
        setMessage({
          type: 'success',
          text:
            role === 'admin'
              ? 'Alt Admin (Çalışan) hesabı oluşturuldu.'
              : 'Şirket Yöneticisi hesabı oluşturuldu.',
        });
        resetForm();
      } else {
        setMessage({ type: 'danger', text: res.message || 'Hesap oluşturulamadı.' });
      }
    } catch {
      setMessage({ type: 'danger', text: 'İstek başarısız.' });
    } finally {
      setLoading(null);
    }
  };

  return (
    <div className="card h-100">
      <div className="card-header">
        <h6 className="mb-0">Alt Admin / Şirket Yöneticisi Oluştur</h6>
      </div>
      <div className="card-body">
        <div className="row g-3">
          <div className="col-md-6">
            <label className="form-label">Ad</label>
            <input
              type="text"
              className="form-control"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Soyad</label>
            <input
              type="text"
              className="form-control"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">E-posta</label>
            <input
              type="email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Şifre</label>
            <input
              type="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div className="col-12">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="createAdminEmailConfirmed"
                checked={isEmailConfirmed}
                onChange={(e) => setIsEmailConfirmed(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="createAdminEmailConfirmed">
                E-posta doğrulanmış olarak oluştur
              </label>
            </div>
          </div>
        </div>

        {message && (
          <div className={`alert alert-${message.type} py-2 mt-3 mb-0`} role="alert">
            {message.text}
          </div>
        )}

        <div className="d-flex flex-wrap gap-2 mt-3">
          <Button
            type="button"
            className="btn btn-primary"
            onClick={() => handleSubmit('admin')}
            disabled={loading !== null}
          >
            {loading === 'admin' ? (
              <span className="spinner-border spinner-border-sm me-1" role="status" />
            ) : null}
            Alt Admin (Çalışan) Oluştur
          </Button>
          <Button
            type="button"
            className="btn btn-outline-primary"
            onClick={() => handleSubmit('companyAdmin')}
            disabled={loading !== null}
          >
            {loading === 'companyAdmin' ? (
              <span className="spinner-border spinner-border-sm me-1" role="status" />
            ) : null}
            Şirket Yöneticisi Oluştur
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CreateAdminForm;
